export default "__VITE_ASSET__DbnwdEvS__"